import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";
// https://wwayne.github.io/react-tooltip/
// https://github.com/wwayne/react-tooltip
import ReactTooltip from "react-tooltip";
import "./Popover.scss";
import { createDataAttributes } from "../../utilities";

const Popover = ({
  id,
  triggerContent,
  popoverContent,
  popoverClass,
  trigger,
  placement,
  outsideClickCloses,
  disabled,
  theme,
  maxWidth,
  dataAttrib,
  ...rest
}) => {
  const popoverClasses = classnames(popoverClass, "uikit__popover");

  const triggerClasses = classnames({
    uikit__popover__disabled: disabled
  });

  // trigger is click by default, app can set to hover manually
  const triggerType = trigger === "hover" ? null : "click";

  // if it's a hover trigger, then create a delay of the hide event
  // so that the tooltip can be interacted with the cursor
  const delay = !triggerType ? 500 : null;

  const colors = {
    white: {
      background: "#fff",
      border: "#bbb",
      text: "#333"
    },
    black: {
      background: "#333",
      border: "#000",
      text: "#eee"
    },
    grey: {
      background: "#f3f3f3",
      border: "#bbb",
      text: "#333"
    },
    blue: {
      background: "#006fcf",
      border: "#0061b6",
      text: "#fff"
    }
  };

  if (typeof theme !== "string") {
    colors.custom = theme;
    theme = "custom";
  }

  return (
    <>
      {React.cloneElement(triggerContent, {
        "data-tip": true,
        "data-for": id,
        "data-event": triggerType,
        "data-place": placement || null,
        "data-tip-disable": disabled,
        className: classnames(triggerContent.props.className, triggerClasses)
      })}
      <ReactTooltip
        id={id}
        effect="solid"
        className={popoverClasses}
        clickable
        delayHide={delay}
        border
        backgroundColor={colors[theme]?.background}
        arrowColor={colors[theme]?.background}
        borderColor={colors[theme]?.border}
        textColor={colors[theme]?.text}
        globalEventOff={outsideClickCloses ? "mousedown" : null}
        {...rest}
      >
        <div style={{ maxWidth }} {...createDataAttributes(dataAttrib)}>
          {popoverContent}
        </div>
      </ReactTooltip>
    </>
  );
};

Popover.propTypes = {
  id: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  triggerContent: propTypes.any.isRequired,
  popoverContent: propTypes.any.isRequired,
  popoverClass: propTypes.string,
  trigger: propTypes.oneOfType([propTypes.oneOf(["hover", "click"])]),
  placement: propTypes.oneOf(["left", "right", "top", "bottom"]),
  outsideClickCloses: propTypes.bool,
  title: propTypes.string,
  disabled: propTypes.bool,
  theme: propTypes.oneOf(["grey", "white", "black", "blue"]),
  maxWidth: propTypes.number,
  dataAttrib: propTypes.arrayOf(Object)
};

Popover.defaultProps = {
  placement: "top",
  outsideClickCloses: true,
  theme: "grey"
};

export default Popover;
